export default "/_next/static/chunks/fonts/MinionPro-It-2b1af5f2be82630ddc2fe5078b4b4a4f.woff2";